import React from 'react';
import {useTranslation} from 'react-i18next';
import {ErrorState} from '../ErrorState/ErrorState';
import {PageFrame} from '../PageFrame/PageFrame';
import {Title} from '../ui/Title';
import styles from './ErrorStatePage.scss';

export function ErrorStatePage() {
  const {t} = useTranslation();
  return (
    <PageFrame
      className={styles.errorStatePage}
      showBackButton={false}
      documentTitle={t('mgw.aria.errorStateDocumentTitle')}
    >
      <ErrorState>
        <Title className={styles.errorStatePageTitle}>{t('mgw.errorStateTitle')}</Title>
      </ErrorState>
    </PageFrame>
  );
}
